export const defaultSort = "CREATE_TIME,DESC;ID";

export const storiesPerPage = 20;
